export enum LoginWindowState {
    NONE,
    LOGIN,
    LOGOUT,
}
